import { isSignedIn, useAuth } from '@/features/scaffolding/components/AuthContext';
import { defaultGcTime, defaultStaleTime } from '@/shared/constants';
import { useQuery } from '@tanstack/react-query';

import { get } from '@truefit/http-utils';

interface QueueCounts {
  waiting: number;
  active: number;
  delayed: number;
  completed: number;
  failed: number;
  total: number;
}

interface QueueStatus {
  success: boolean;
  queueName: string;
  overallCounts: QueueCounts;
  jobTypes: string[];
  jobTypeDistribution: Record<string, number>;
}

export const useGetClipExportQueueStatusQuery = () => {
  const { sessionState } = useAuth();
  const isReady = isSignedIn(sessionState);

  return useQuery({
    queryKey: ['ClipExportQueueStatus'],
    queryFn: async () => {
      const { data } = await get<QueueStatus>(`/v1.0/internals/queues`);
      return data;
    },
    refetchInterval(query) {
      return query?.data?.success ? 5_000 : false; // Refetch every 5 seconds if the data is successful
    },
    enabled: isReady,
    staleTime: defaultStaleTime, // Data considered fresh for 30 seconds
    gcTime: defaultGcTime, // Data will be garbage collected after 5 minutes
  });
};

export default useGetClipExportQueueStatusQuery;
